var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03298 13.6167L6.78298 10.8667C6.70577 10.5843 6.66654 10.2928 6.66632 10C6.66581 8.1596 8.15737 6.66721 9.99782 6.66671H9.99965C10.2924 6.66693 10.5839 6.70617 10.8663 6.78338L12.983 4.66671C12.0232 4.33565 11.0149 4.16668 9.99965 4.16671C6.35575 4.1149 3.059 6.32047 1.71632 9.70837C1.64965 9.89711 1.64965 10.103 1.71632 10.2917C2.19829 11.5764 2.99482 12.7196 4.03298 13.6167Z",
    fill: "#808191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9663 6.38338C15.7612 6.19707 15.5441 6.02447 15.3163 5.86671L18.0913 3.09171C18.4194 2.76627 18.4216 2.23647 18.0961 1.90837C17.7707 1.58028 17.2409 1.57813 16.9128 1.90357C16.9112 1.90516 16.9096 1.90677 16.908 1.90837L1.90798 16.9084C1.583 17.2359 1.583 17.7642 1.90798 18.0917C2.23661 18.4139 2.76268 18.4139 3.09132 18.0917L6.18298 15C6.45266 15.1304 6.73112 15.2418 7.01631 15.3334C7.97612 15.6644 8.98435 15.8334 9.99965 15.8334C13.6435 15.8852 16.9403 13.6796 18.283 10.2917C18.3496 10.103 18.3496 9.89711 18.283 9.70838C17.801 8.42373 17.0045 7.2805 15.9663 6.38338ZM9.99965 13.3334C9.70686 13.3332 9.41541 13.2939 9.13298 13.2167L13.2163 9.13337C13.2935 9.4158 13.3328 9.70725 13.333 10C13.3335 11.8405 11.8419 13.3329 10.0015 13.3334H9.99965Z",
    fill: "#808191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.409f8de852f617062f236b1a719387cc.svg";
export { ForwardRef as ReactComponent };